var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { ConsentDateSearchInput, ConsentStatus, ConsentType } from "./consent.dtos";
import { BaseStudySearchInput, StudyDto } from "./study.dtos";
import { USAStates } from "./usaStates";
export class ConsentRequestDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConsentRequestDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConsentRequestDto.prototype, "identifiedPatientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], ConsentRequestDto.prototype, "patientId", void 0);
__decorate([
    ValidateNested(),
    Type(() => StudyDto),
    __metadata("design:type", StudyDto)
], ConsentRequestDto.prototype, "study", void 0);
__decorate([
    IsEnum(ConsentType),
    __metadata("design:type", String)
], ConsentRequestDto.prototype, "consentType", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], ConsentRequestDto.prototype, "timestamp", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConsentRequestDto.prototype, "pending", void 0);
export class ConsentRequestSearchInput {
}
__decorate([
    ValidateNested(),
    Type(() => BaseStudySearchInput),
    IsOptional(),
    __metadata("design:type", BaseStudySearchInput)
], ConsentRequestSearchInput.prototype, "study", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ConsentRequestSearchInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(ConsentType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ConsentRequestSearchInput.prototype, "consentType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ConsentRequestSearchInput.prototype, "identifiedPatientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ConsentRequestSearchInput.prototype, "patientId", void 0);
__decorate([
    IsEnum(USAStates),
    IsOptional(),
    __metadata("design:type", String)
], ConsentRequestSearchInput.prototype, "patientState", void 0);
__decorate([
    ValidateNested(),
    Type(() => ConsentDateSearchInput),
    IsOptional(),
    __metadata("design:type", ConsentDateSearchInput)
], ConsentRequestSearchInput.prototype, "timestamp", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ConsentRequestSearchInput.prototype, "pending", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ConsentRequestSearchInput.prototype, "distinctPending", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ConsentRequestSearchInput.prototype, "includeConsentingByLink", void 0);
__decorate([
    IsEnum(ConsentStatus, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ConsentRequestSearchInput.prototype, "includePatientStudyConsentStatuses", void 0);
export class ConsentRequestSearchResult {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ConsentRequestSearchResult.prototype, "total", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ConsentRequestSearchResult.prototype, "totalStudies", void 0);
__decorate([
    Type(() => ConsentRequestDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ConsentRequestSearchResult.prototype, "results", void 0);
